if (!customElements.get('mthr-buy-gallery')) customElements.define('mthr-buy-gallery', class extends HTMLElement {
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.frames=[...this.querySelectorAll('[data-frame]')];this.buttons=[...this.querySelectorAll('[data-thumb]')];
  this.defaultImage=this.frames[0]?.querySelector('img')?.cloneNode(true);
  this.buttons.forEach(b=>b.addEventListener('click',()=>this.select(b.dataset.thumb)));
  if(this.frames.length)this.select(this.frames[0].dataset.frame);
  const active=this.closest('.shopify-section')?.querySelector('.formthr-buy-box__flavor--active');
  if(active)this.selectVariant(active.dataset.variantId);
  const stage=this.querySelector('.mthr-gallery-stage');let start;
  stage.addEventListener('touchstart',e=>{start={x:e.touches[0].clientX,y:e.touches[0].clientY}},{passive:true});
  stage.addEventListener('touchend',e=>{if(!start)return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;start=null;if(Math.abs(dx)<45||Math.abs(dx)<Math.abs(dy))return;const n=this.frames.findIndex(f=>!f.hidden),next=Math.max(0,Math.min(this.frames.length-1,n+(dx<0?1:-1)));if(this.frames[next])this.select(this.frames[next].dataset.frame)},{passive:true});
 }
 select(id){this.frames.forEach(f=>f.hidden=f.dataset.frame!==id);this.buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.thumb===id)));}
 selectVariant(id){
  const template=[...this.querySelectorAll('template[data-variant-id]')].find(t=>t.dataset.variantId===String(id));
  return this.showImage(template?.content.querySelector('img') || this.defaultImage);
 }
 selectCombo(first,second){
  const key=[first,second].map(name=>name.toLowerCase().trim()).sort().join('--');
  const template=[...this.querySelectorAll('template[data-combo-key]')].find(t=>t.dataset.comboKey===key);
  return this.showImage(template?.content.querySelector('img'));
 }
 showImage(source){
  const frame=this.frames[0],thumb=this.buttons[0];
  if(!source||!frame||!thumb)return false;
  const image=source.cloneNode(true);image.loading='eager';frame.replaceChildren(image);
  const preview=source.cloneNode(true);preview.alt='';preview.sizes='100px';thumb.replaceChildren(preview);
  thumb.setAttribute('aria-label','Show '+(image.alt||'selected flavor')+' image');
  delete frame.dataset.mediaId;
  this.select(frame.dataset.frame);return true;
 }
 setActiveMedia(id){const f=this.frames.find(f=>f.dataset.mediaId===id);if(f)this.select(f.dataset.frame);}
});
